import { lazy, Suspense } from 'react';
import RingLoader from 'react-spinners/RingLoader';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Layout from './components/Layout';
import Public from './components/Public';
import PersistLogin from './components/PersistLogin';
import RequireAuth from './components/RequireAuth';
import Anonymous from './components/Anonymous';

const EmailVerify = lazy(() => import('./components/EmailVerify'));
const EmailUnsubscribe = lazy(() => import('./components/EmailUnsubscribe'));
const Login = lazy(() => import('./components/Login'));
const RestApiGui = lazy(() => import('./components/RestApiGui'));

export default function App() {
  return (
    <>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="*" element={<Navigate replace to="/" />} />
          {/* <Route path="/Said-Rasinlic-CV_1.pdf/favicon.ico" render={() => null} /> */}
          <Route index element={<Public />} />
        </Route>
        <Route
          path="/subscribe/:id/verification/:subscribeToken"
          element={(
            <Suspense fallback={(
              <div>
                <RingLoader
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                  }}
                  color="#2f2fa2"
                />
              </div>
            )}
            >
              <EmailVerify />
            </Suspense>
          )}
        />
        <Route
          path="/unsubscribe/:unsubscribeToken"
          element={(
            <Suspense fallback={(
              <div>
                <RingLoader
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                  }}
                  color="#2f2fa2"
                />
              </div>
            )}
            >
              <EmailUnsubscribe />
            </Suspense>
          )}
        />
        <Route path="/spanel" element={<Layout />}>
          <Route element={<PersistLogin />}>
            <Route element={<Anonymous />}>
              <Route
                index
                element={(
                  <Suspense fallback={(
                    <div>
                      <RingLoader
                        style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                        }}
                        color="#2f2fa2"
                      />
                    </div>
                  )}
                  >
                    <Login />
                  </Suspense>
                )}
              />
            </Route>

            <Route element={<RequireAuth />}>
              <Route
                path="home"
                element={(
                  <Suspense fallback={(
                    <div>
                      <RingLoader
                        style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                        }}
                        color="#2f2fa2"
                      />
                    </div>
                  )}
                  >
                    <RestApiGui />
                  </Suspense>
                )}
              />
            </Route>
          </Route>
        </Route>
      </Routes>
    </>
  );
}
